/**
 * ProcessList
 * Componente para mostrar procesos en ejecución
 */

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
} from '@mui/material';
import type { ProcessInfo } from '@/types/metrics';
import { formatBytes, formatPercent } from '@/types/metrics';

interface ProcessListProps {
  processes: ProcessInfo[];
  maxItems?: number;
}

export const ProcessList: React.FC<ProcessListProps> = ({ processes, maxItems = 10 }) => {
  const sorted = [...processes].sort((a, b) => b.cpuPercent - a.cpuPercent).slice(0, maxItems);

  if (sorted.length === 0) {
    return (
      <Box textAlign="center" py={2}>
        <Typography variant="body2" color="text.secondary">
          No hay procesos
        </Typography>
      </Box>
    );
  }

  return (
    <TableContainer component={Paper} variant="outlined">
      <Table size="small">
        <TableHead>
          <TableRow sx={{ backgroundColor: 'action.hover' }}>
            <TableCell>Proceso</TableCell>
            <TableCell align="right">PID</TableCell>
            <TableCell align="right">CPU</TableCell>
            <TableCell align="right">Memoria</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {sorted.map((proc) => (
            <TableRow key={proc.pid} hover>
              <TableCell sx={{ fontFamily: 'monospace', fontSize: '0.85rem' }}>
                {proc.name}
              </TableCell>
              <TableCell align="right" sx={{ fontFamily: 'monospace' }}>
                {proc.pid}
              </TableCell>
              <TableCell align="right">{formatPercent(proc.cpuPercent)}</TableCell>
              <TableCell align="right">{formatBytes(proc.memBytes)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
